import { Checkbox, Table } from '@mairistem/composants';
import _ from 'lodash';

import type { FactureType } from '@/types';

import FactureRecuTableOptions from '../../FactureRecuTableOptions';

interface ModalEncaissementLoocTableHeaderProps {
  factures: FactureType[];
  selected: number[];
  produitsMontants: boolean;
  toggleProduitsMontants: () => void;
  onSelect: (checked: boolean) => void;
}

const ModalEncaissementLoocTableHeader = (props: ModalEncaissementLoocTableHeaderProps) => {
  const { factures, selected, produitsMontants, toggleProduitsMontants, onSelect } = props;

  return (
    <Table.Header
      style={{
        position: 'sticky',
        top: -1,
        background: 'white',
        zIndex: 10,
      }}
    >
      <Table.Row>
        {_.size(factures) > 1 && (
          <Table.HeaderCell style={{ width: 40 }} textAlign="center">
            <Checkbox
              data-testid="checkbox-select-all"
              checked={_.isEqual(_.size(factures), _.size(selected))}
              onChange={(e, data) => onSelect(data.checked)}
            />
          </Table.HeaderCell>
        )}
        <Table.HeaderCell style={{ width: 200 }}>N° de contrat</Table.HeaderCell>
        <Table.HeaderCell>Payeur</Table.HeaderCell>
        <Table.HeaderCell>Lieu</Table.HeaderCell>
        {produitsMontants && <Table.HeaderCell textAlign="center">Produits</Table.HeaderCell>}
        <Table.HeaderCell style={{ width: 175 }} textAlign="right">
          Montant à encaisser
        </Table.HeaderCell>
        {false && (
          <FactureRecuTableOptions
            onProduitMontantsClick={toggleProduitsMontants}
            produitsMontantsVisible={produitsMontants}
          />
        )}
      </Table.Row>
    </Table.Header>
  );
};

export default ModalEncaissementLoocTableHeader;
